import script from "./AccessDenied.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDenied.vue?vue&type=script&setup=true&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=19715be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19715be8"]])

export default __exports__